import { fetch, buildUrl } from 'domain/Api';
import { createApiActionCreator, ApiCall } from 'omni-common-ui';

const ACTION_OBJECT_NAME = 'SHORT_ANSWER';
export const FETCH_SHORT_ANSWER_REQUEST = `FETCH_${ACTION_OBJECT_NAME}_REQUEST`;
export const FETCH_SHORT_ANSWER_SUCCESS = `FETCH_${ACTION_OBJECT_NAME}_SUCCESS`;
export const FETCH_SHORT_ANSWER_FAILURE = `FETCH_${ACTION_OBJECT_NAME}_FAILURE`;
export const SUBMIT_SHORT_ANSWER_REQUEST = `SUBMIT_${ACTION_OBJECT_NAME}_REQUEST`;
export const SUBMIT_SHORT_ANSWER_SUCCESS = `SUBMIT_${ACTION_OBJECT_NAME}_SUCCESS`;
export const SUBMIT_SHORT_ANSWER_FAILURE = `SUBMIT_${ACTION_OBJECT_NAME}_FAILURE`;


const DISABLE_DEFAULT_ACTION_EXTRAS = { disableDefault: true };

const buildShortAnswerURL = (activityId, studentId) =>
  buildUrl(`/writing-assignment-activities/${activityId}/short-answer?studentId=${studentId}`);

const createfetchShortAnswerActions = (activityId, studentId) =>
  createApiActionCreator(
    ACTION_OBJECT_NAME,
    buildShortAnswerURL(activityId, studentId),
    'GET',
    DISABLE_DEFAULT_ACTION_EXTRAS,
    { activityId, studentId },
    DISABLE_DEFAULT_ACTION_EXTRAS
  );

export const fetchShortAnswer = (activityId, studentId) =>
  createfetchShortAnswerActions(activityId, studentId);

export function fetchShortAnswerIfNeed(activityId, studentId) {
  const method = 'GET';
  return (dispatch, getState) => {
    const state = getState();
    if (! ApiCall.shouldPerform(state,
      { method, url: buildShortAnswerURL(activityId, studentId) })) {
      return false;
    }
    return dispatch(fetchShortAnswer(activityId, studentId));
  };
}


export const submitShortAnswer = (id, payload) => (dispatch) => {
  const url = buildUrl(`/writing-assignment-activities/${id}/short-answer-remarks`);
  const method = 'PUT';
  return dispatch(submitShortAnswerRequest()).payload
    .then((response) => dispatch(submitShortAnswerSuccess(response)))
    .catch((error) => dispatch(submitShortAnswerFailure(error)));

  function submitShortAnswerRequest() {
    const request = fetch(url,
      {
        method,
        body: JSON.stringify(payload),
      }
    );
    return ApiCall.createAction({
      type: SUBMIT_SHORT_ANSWER_REQUEST,
      payload: request,
      url,
      method,
    });
  }

  function submitShortAnswerSuccess() {
    return ApiCall.createAction({
      type: SUBMIT_SHORT_ANSWER_SUCCESS,
      url,
      method,
    });
  }

  function submitShortAnswerFailure(error) {
    return ApiCall.createAction({
      type: SUBMIT_SHORT_ANSWER_FAILURE,
      url,
      method,
      error,
    });
  }
};



// WEBPACK FOOTER //
// ./data/WritingAssignment/ShortAnswer/actions.js